import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import logo from "../../assets/logoS.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Banner = () => {
  const [products, setProducts] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsCollection = collection(db, "products");
        const productsSnapshot = await getDocs(productsCollection);
        const productsList = productsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const sortedProducts = productsList
          .filter((product) => product.showInSlider)
          .sort((a, b) => b.timestamp - a.timestamp);
        const lastThreeProducts = sortedProducts.slice(0, 10);
        setProducts(lastThreeProducts);
      } catch (error) {
        console.error("Error fetching products: ", error);
      }
    };
    fetchProducts();
  }, []);

  return (
    <Container>
      <Swiper
        className="swiper"
        pagination={true}
        modules={[Pagination, Autoplay]}
        slidesPerView={"auto"}
        spaceBetween={4}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        speed={1000}
      >
        {products.map((product) => (
          <SwiperSlide className="slide" key={product.id}>
            <img src={product.image} alt={product.name} />
            <div className="details">
              <h3>{t("inspired")}</h3>
              <h1>{product.name}</h1>
              <h2>
                <span>{t("gender")}: </span>
                {product.category.charAt(0).toUpperCase() +
                  product.category.slice(1)}
              </h2>
              <h2>
                <span>{t("seasons")}: </span>
                {Array.isArray(product.seasons)
                  ? product.seasons.map(s => t(`season${s}`)).join(", ")
                  : t(`season${product.seasons}`)}
              </h2>
              <p>{product.description}</p>
              <Link to={`/products/${product.name}`} className="link-styles">
                <button>{t("orderNow")}</button>
              </Link>
            </div>
            <img className="logo" src={logo} alt="" />
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
};

const Container = styled.div`
  padding: 6em 0;
  .swiper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .slide {
      padding: 5% 10%;
      width: 100%;
      height: 70vh;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
      gap: 8%;
      background: #303030;
      position: relative;
      user-select: none;
      .details {
        h1 {
          font-size: 5vw;
          font-family: "The Seasons", sans-serif;
          font-weight: 300;
        }
        h3 {
          color: var(--primaryColor);
          font-family: "Comfortaa";
        }
        h2 {
          font-family: "Comfortaa", sans-serif;
          font-size: 16px;
          margin-bottom: 10px;
          span {
            color: var(--primaryColor);
            font-weight: 500;
            font-size: 21px;
          }
        }
        p {
          color: #a8a8a8;
        }
        button {
          background: white;
          font-family: "Comfortaa", sans-serif;
          padding: 12px 20px;
          border: none;
          border-radius: 30px;
          font-size: 19px;
          margin-top: 1em;
          cursor: pointer;
          transition: 0.4s;
          &:hover {
            background: var(--primaryColor);
            color: white;
          }
        }
      }
      img {
        height: 120%;
        max-width: 57%;
        object-fit: contain;
      }
      .logo {
        position: absolute;
        width: 14%;
        right: 4%;
        top: -25%;
        opacity: 0.3;
        min-width: 200px;
      }
    }
    .swiper-pagination {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }

    .swiper-pagination-bullet {
      width: 3%;
      height: 5px;
      background-color: #3d3d3d;
      opacity: 0.7;
      margin: 0 5px;
      border-radius: 5px;
      cursor: pointer;
      box-shadow: 0 0 1px 1px gray;
      transition: background-color 0.3s ease;
    }

    .swiper-pagination-bullet-active {
      background-color: var(--primaryColor);
      opacity: 1;
    }
  }
  @media (max-width: 750px) {
    padding: 5em 0;
    .swiper {
      .slide {
        gap: 1em;
        flex-direction: column;
        height: 70vh;
        width: 96%;
        img {
          height: 37%;
          max-width: 100%;
        }
        .details {
          h1 {
            font-size: 2em;
          }
          h2 {
            font-size: 15px;
            margin-bottom: 3px;
            span {
              font-size: 17px;
            }
          }
          p {
            font-size: 13px;
            max-height: 90px;
            overflow: scroll;
          }
          button {
            display: flex;
          }
        }
        .logo {
          width: 35%;
          top: -8%;
          opacity: 0.1;
          min-width: 50px;
        }
      }
    }
  }
  @media (max-width: 500px) {
    .swiper {
      .slide {
        height: 65vh;
        padding: 1px 10%;
        img {
          height: 27%;
        }
        .logo {
          top: 0%;
        }
      }
    }
  }
`;

export default Banner;
